namespace $ {
	$mol_style_define( $bog_builderui_gallery, {
		display: 'block',
		columnWidth: '340px',
		columnGap: '1rem',
		flex: {
			grow: 1,
		},
	} )
}
